import { render, staticRenderFns } from "./UsageDetailed.vue?vue&type=template&id=35995348&scoped=true"
import script from "./UsageDetailed.vue?vue&type=script&lang=js"
export * from "./UsageDetailed.vue?vue&type=script&lang=js"
import style0 from "./UsageDetailed.vue?vue&type=style&index=0&id=35995348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35995348",
  null
  
)

export default component.exports